import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DiamondIcon from '@mui/icons-material/Diamond';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import mission from '../assets/mission-1.webp';

const Why = () => {
    return (
        <Box sx={{width:'100%', backgroundColor:'white', pt:'50px', pb:'50px'}}>
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, sm: 3 },
                mx: 'auto',
                fontFamily: 'Nunito, sans-serif',
                width: {
                    xs: '95%',
                    sm: '100%',
                    md: '100%',
                    lg: '85%',
                    xl: '85%',
                },
            }}
            maxWidth="lg"
            backgroundColor="white"
        >
            <Box
                component="img"
                src={mission}
                alt="About"
                sx={{
                    width: '50%',
                    height: '70%',
                    borderRadius: 2,
                    display: { xs: 'none', md: 'block' },
                    mr: { md: 8 },
                }}
            />

            {/* Right Content */}
            <Box sx={{ width: { xs: '100%', md: '50%' }, mt: { xs: 4, md: 0 } }}>
                <Typography
                    variant="h5"
                    sx={{
                        fontFamily: 'Rajdhani',
                        fontWeight: 600,
                        fontSize: '19px',
                        color: '#0c5adb',
                    }}
                >
                    WHY CHOOSE US
                </Typography>

                <Typography
                    variant="h2"
                    sx={{
                        fontFamily: 'Rajdhani',
                        color: '#232323',
                        fontWeight: 'bold',
                        lineHeight: 1.2,
                    }}
                >
                    What's The Reason You Choose

                    <br />
                    Services With  <span style={{ color: '#075AD6' }}>Loopsys</span>
                </Typography>

                <Typography fontSize={'13px'} color="#686868" fontFamily={'Nunito'} my={'20px'}>
                    At Loopsys technologies, we go beyond just providing services —
                    we deliver value, reliability, and innovation. Here’s why businesses
                    trust us:
                </Typography>

                {/* Q&A Section */}
                <Box sx={{ mt: 2, color: '#232323', fontFamily: 'Nunito' }}>
                    {[
                        {
                            icon: (
                                <DiamondIcon
                                    sx={{
                                        color: '#1976d2',
                                        fontSize: 40,
                                        mt: 2,
                                        mr: 2,
                                    }}
                                />
                            ),
                            question: 'Ensure Quality Product',
                            answer:
                                'We deliver reliable, high-performance solutions tailored to your business needs, ensuring top-notch quality every step of the way.',
                        },
                        {
                            icon: (
                                <SupportAgentIcon
                                    sx={{
                                        color: '#1976d2',
                                        fontSize: 40,
                                        mt: 2,
                                        mr: 2,
                                    }}
                                />
                            ),
                            question: 'World Class Support System',
                            answer:
                                'Our dedicated support team is available when you need it most, offering fast, effective assistance to keep your operations running smoothly.',
                        },
                    ].map((item, index) => (
                        <Box
                            key={index}
                            sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}
                        >
                            {item.icon}
                            <Box>
                                <Typography variant="subtitle1" fontFamily={'Rajdhani'} fontWeight="bold">
                                    {item.question}
                                </Typography>
                                <Typography variant="body2" fontFamily={'nunito'} fontWeight={500}>
                                    {item.answer}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* Progress Bars */}
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="subtitle2" fontWeight="light">
                            Business Success
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="light">90%</Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={90}
                        sx={{
                            height: 4,
                            borderRadius: 3,
                            mb: 2,
                            backgroundColor: '#e0e0e0',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#1976d2',
                            },
                        }}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="subtitle2" fontWeight="light">
                            Technology Skills
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="light">85%</Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={85}
                        sx={{
                            height: 4,
                            borderRadius: 3,
                            backgroundColor: '#e0e0e0',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#1976d2',
                            },
                        }}
                    />
                </Box>

                {/* Button */}
                <Button
                    sx={{
                        mt: '50px',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '3px',
                        px: '10px',
                        py: '3px',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        fontFamily: 'Rajdhani',
                        fontSize: '17px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        backgroundColor: '#0c5ADB',
                        color: '#fff',
                        border: '2px solid #0c5ADB',
                        width: 'fit-content', // 👈 Added line
                        transition:
                            'color 0.4s ease-in-out, background-color 0.4s ease-in-out',

                        '& span, & .arrow-circle': {
                            position: 'relative',
                            zIndex: 1,
                        },

                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            backgroundColor: '#fff',
                            zIndex: 0,
                            transform: 'translateX(100%)',
                            transition: 'transform 0.4s ease-in-out',
                        },

                        '&:hover::before': {
                            transform: 'translateX(0%)',
                        },

                        '&:not(:hover)::before': {
                            transform: 'translateX(-100%)',
                        },

                        '& .arrow-circle': {
                            backgroundColor: '#fff',
                            color: '#075AD6',
                            borderRadius: '50%',
                            padding: '3px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.4s ease-in-out',
                        },

                        '&:hover': {
                            color: '#075AD6',
                            '& .arrow-circle': {
                                backgroundColor: '#0c5ADB',
                                color: '#fff',
                            },
                        },
                    }}
                    component={Link}
                    to="/services"
                >
                    <span>OUR SERVICES</span>
                    <span className="arrow-circle">
                        <ArrowForwardIcon fontSize="small" />
                    </span>
                </Button>

            </Box>
        </Box>
        </Box>
    );
};

export default Why;
